import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
  Chip,
  Skeleton,
  Pagination,
  IconButton,
  FormControl,
  Autocomplete,
} from "@mui/material";
import styles, { pageScrollStyle } from "../../../../styles/styles";
import SearchIcon from "@mui/icons-material/Search";
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import ScheduleRoundedIcon from "@mui/icons-material/ScheduleRounded";
import { DeleteOutlineRounded } from "@mui/icons-material";
import BorderColorRoundedIcon from "@mui/icons-material/BorderColorRounded";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { useDialog } from "../../../DialogContext";
import CreatecaseTemplateForm from "./CreatecaseTemplateForm";
import { useDispatch, useSelector } from "react-redux";
import {
  getCaseTemplate,
  getPracticeArea,
} from "../../../../redux/Apps/Lawyerapp/CaseSlice/CaseSlice";
import { backend_api } from "../../../../static/server";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import { toast } from "react-toastify";
import axios from "axios";
import { LoadingButton } from "@mui/lab";
import noDataFound from "../../../../assets/no-data-found.webp";
import { Controller, useForm } from "react-hook-form";

const TemplateCardSkeleton = () => (
  <Box
    sx={{
      borderRadius: "0.625rem",
      border: "1px solid #DADADA",
      overflow: "hidden",
    }}
  >
    <Box sx={{ p: "0.5rem", bgcolor: "#F5F5F5" }}>
      <Skeleton variant="text" width="70%" height={20} />
    </Box>
    <Box sx={{ p: "1rem" }}>
      <Skeleton variant="text" width="90%" />
      <Skeleton variant="text" width="80%" />
      <Skeleton variant="text" width="85%" />

      <Box sx={{ mt: "0.75rem" }}>
        <Skeleton variant="text" width="60%" height={19} />
      </Box>
      <Box sx={{ mt: "0.3rem" }}>
        <Skeleton variant="text" width="70%" height={19} />
      </Box>
      <Box sx={{ mt: "0.3rem" }}>
        <Skeleton variant="text" width="65%" height={19} />
      </Box>
    </Box>
    <Box
      sx={{
        borderTop: "1px solid #DADADA",
        height: "2rem",
        px: "0.5rem",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Skeleton variant="text" width="50%" height={24} />
    </Box>
  </Box>
);

const NoTemplateFound = () => (
  <Box
    sx={{
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "1rem",
    }}
  >
    <Box sx={{ height: "15rem" }}>
      <img
        src={noDataFound}
        alt="No Data"
        style={{
          height: "100%",
          width: "100%",
          objectFit: "contain",
        }}
        onError={(e) => {
          e.onerror = null;
          e.target.src = require("../../../../assets/no-data-found.webp");
        }}
      />
    </Box>
    <Typography
      variant="body1"
      sx={{
        fontSize: "0.9rem",
        textAlign: "center",
      }}
    >
      No templates available. Please create a new template to get started.
    </Typography>
  </Box>
);

const CaseTemplate = () => {
  const dispatch = useDispatch();
  const { showDialog, closeDialog } = useDialog();
  const [filterBtn, setFilterBtn] = useState(1);
  const [duplicateLoad, setDuplicateLoad] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState({});
  const [expandedDesc, setExpandedDesc] = useState({});
  const { token, userId, lawerId } = useSelector((state) => state.user);
  const { allPracticeArea, allCaseTemplate, loading, error } = useSelector(
    (state) => state.case
  );
  const {
    page,
    pageSize,
    rowCount,
    nextPage,
    previousPage,
    count,
    next,
    previous,
  } = useSelector((state) => state.case.caseTemplatePagination);

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });

  useEffect(() => {
    dispatch(
      getCaseTemplate({
        url: `${backend_api}case/template-register/`,
        token: token,
        // page: 1,
        // pageSize: 10,
      })
    );
    dispatch(
      getPracticeArea({
        url: `${backend_api}case/case-type/?case_service_type=practice_area`,
        token: token,
      })
    );
  }, [dispatch, token]);

  console.log(
    "allCaseTemplate",
    allCaseTemplate,
    pageSize,
    rowCount,
    count,
    nextPage,
    previousPage
  );

  const handleDeleteTemplate = async (template) => {
    const templateId = template?.id;
    const customFiledId = template?.custom_fields[0]?.id;
    setDeleteLoading((prev) => ({ ...prev, [templateId]: true }));
    try {
      const res = await axios.delete(
        `${backend_api}case/template-register/${templateId}/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );
      if (res) {
        const customFieldApires = await axios.delete(
          `${backend_api}custom-field/${customFiledId}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Token ${token}`,
            },
          }
        );

        if (customFieldApires) {
          toast.success("Template deleted successfully");
          // Refresh the template list
          dispatch(
            getCaseTemplate({
              url: `${backend_api}case/template-register/`,
              token: token,
            })
          );
        }
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete template");
    } finally {
      dispatch(
        getCaseTemplate({
          url: `${backend_api}case/template-register/`,
          token: token,
        })
      );
      setDeleteLoading((prev) => ({ ...prev, [templateId]: false }));
    }
  };

  const handleEditTemplate = (template) => {
    // Implement edit template functionality
    // console.log("Edit template:", template?.custom_fields[0]?.field_data);
    // const formData = template?.custom_fields[0]?.field_data;
    showDialog(<CreatecaseTemplateForm editTempData={template} />, {
      dialogTitle: "Matter Template",
      fullScreen: true,
      width: "100%",
      formType: "matter",
      dialogId: "create-matter-template",
    });
  };

  const handleDuplicateTemplate = async (template) => {
    setDuplicateLoad(true);
    console.log("duplicate template:", template);

    if (
      !template?.custom_fields[0]?.field_data?.createNewMatter?.sections ||
      template?.custom_fields[0]?.field_data?.createNewMatter?.sections
        ?.length === 0
    ) {
      toast.error(
        "Please configure sections in Create New Matter template first"
      );
      setDuplicateLoad(false);
      return;
    }
    try {
      const customFieldApiData = {
        created_by: userId,
        under_lawer: lawerId,
        field_name: template?.custom_fields[0]?.field_name,
        field_data: {
          createNewMatter:
            template?.custom_fields[0]?.field_data?.createNewMatter,
          quickCreateNewMatter:
            template?.custom_fields[0]?.field_data?.quickCreateNewMatter,
          unUsedFieldsTypes:
            template?.custom_fields[0]?.field_data?.unUsedFieldsTypes,
          usedFieldsTypes:
            template?.custom_fields[0]?.field_data?.usedFieldsTypes,
        },
      };
      const customFieldApires = await axios.post(
        `${backend_api}custom-field/`,
        customFieldApiData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );
      if (customFieldApires?.data) {
        console.log(customFieldApires?.data?.id);
        const templateOrgData = {
          created_by: userId,
          under_lawer: lawerId,
          template_name: template?.template_name,
          practice_area: template?.practice_area?.id,
          custom_fields: [customFieldApires?.data?.id],
          linked_templated: template?.id,
        };

        const res = await axios.post(
          `${backend_api}case/template-register/`,
          templateOrgData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Token ${token}`,
            },
          }
        );
        console.log(res);
        toast.success("Duplicate successfully");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to duplicate");
    } finally {
      dispatch(
        getCaseTemplate({
          url: `${backend_api}case/template-register/`,
          token: token,
        })
      );
      setDuplicateLoad(false);
    }
  };
  const handlePageChange = (e, value) => {
    e.preventDefault();
    dispatch(
      getCaseTemplate({
        url: `${backend_api}case/template-register/`,
        token: token,
        page: value,
        pageSize: pageSize,
      })
    );
  };

  const onSubmit = (tempId) => async (data) => {
    console.log(tempId, data);
    try {
      const res = await axios.patch(
        `${backend_api}case/template-register/${tempId}/`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );
      console.log(res);
      if (res?.status === 200) {
        toast.success("Note added successfully");
      }
    } catch (err) {
      toast.error("Failed to add the note ");
    } finally {
      closeDialog();
      dispatch(
        getCaseTemplate({
          url: `${backend_api}case/template-register/`,
          token: token,
        })
      );
    }
  };
  const handleAddNote = (template) => {
    setValue("template_name", template?.template_name);
    setValue("practice_area", template?.practice_area?.id);
    setValue("template_description", template?.template_description);
    showDialog(
      <Box>
        <form onSubmit={handleSubmit(onSubmit(template?.id))}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              p: "1rem",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <Controller
                name="template_name"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Template Name"
                    size="small"
                    fullWidth
                  />
                )}
              />
              <Controller
                name="practice_area"
                control={control}
                render={({ field }) => (
                  <FormControl size="small" fullWidth>
                    <Autocomplete
                      size="small"
                      fullWidth
                      options={allPracticeArea || []}
                      getOptionLabel={(option) => option?.name || ""}
                      value={
                        allPracticeArea?.find(
                          (option) => option?.id === field?.value
                        ) || null
                      }
                      onChange={(_, newValue) =>
                        field.onChange(newValue ? newValue?.id : null)
                      }
                      isOptionEqualToValue={(option, value) =>
                        option?.id === value?.id
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Practice Area"
                          size="small"
                          fullWidth
                        />
                      )}
                    />
                  </FormControl>
                )}
              />
            </Box>
            <Controller
              name="template_description"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  {...field}
                  multiline
                  rows={3}
                  fullWidth
                  label="Description"
                  error={!!errors?.template_description}
                  helperText={
                    errors?.template_description ? "This field is required" : ""
                  }
                />
              )}
            />
          </Box>
          <Box
            sx={{
              height: "fit-content",
              borderTop: "1px solid #ddd",
              position: "sticky",
              bottom: 0,
              backdropFilter: "blur(10px)",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              p: "0.5rem",
              zIndex: 1000,
              gap: "0.5rem",
            }}
          >
            <Button
              variant="outlined"
              size="small"
              onClick={() => closeDialog()}
            >
              Cancel
            </Button>
            <LoadingButton
              //   loading={submitLoading}
              variant="contained"
              color="primary"
              type="submit"
              size="small"
            >
              Save Note
            </LoadingButton>
          </Box>
        </form>
      </Box>,
      { dialogTitle: "Add note" }
    );
  };

  const handleEditDescription = (template) => {
    handleAddNote(template);
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <div className="bg-white rounded-lg items-center shadow-md p-2">
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h2 className={`${styles.title}`}>Matter Templates</h2>
              <Box className="flex gap-4">
                <Button
                  size="small"
                  variant="contained"
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => {
                    showDialog(<CreatecaseTemplateForm />, {
                      dialogTitle: "Matter Template",
                      fullScreen: true,
                      width: "100%",
                      formType: "matter",
                      dialogId: "create-matter-template",
                    });
                  }}
                >
                  New Template
                </Button>
              </Box>
            </Box>
          </div>
          <div>
            <div className="w-full flex">
              <Box
                className="bg-white rounded-lg h-[85vh] p-2 w-full shadow-sm"
                sx={{
                  ...pageScrollStyle,
                  overflow: "auto",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  gap: "1rem",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    height: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        gap: "0.5rem",
                        border: "1px solid #e5e5e5",
                        p: "0.2rem",
                        borderRadius: "0.5rem",
                      }}
                    >
                      <Button
                        variant={filterBtn === 1 ? "contained" : "text"}
                        size="small"
                        sx={{
                          fontSize: "0.8rem",
                          textTransform: "capitalize",
                          transition: "all 0.2s ease",
                        }}
                        onClick={() => {
                          setFilterBtn(1);
                          dispatch(
                            getCaseTemplate({
                              url: `${backend_api}case/template-register/`,
                              token: token,
                              page: 1,
                              pageSize: pageSize,
                            })
                          );
                        }}
                      >
                        All Templates
                      </Button>
                      <Button
                        variant={filterBtn === 2 ? "contained" : "text"}
                        size="small"
                        sx={{
                          textTransform: "capitalize",
                          fontSize: "0.8rem",
                          transition: "all 0.2s ease",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          setFilterBtn(2);
                          dispatch(
                            getCaseTemplate({
                              url: `${backend_api}case/template-register/?is_standard=false`,
                              token: token,
                              page: 1,
                              pageSize: pageSize,
                            })
                          );
                        }}
                      >
                        My Templates
                      </Button>
                      <Button
                        variant={filterBtn === 3 ? "contained" : "text"}
                        size="small"
                        sx={{
                          textTransform: "capitalize",
                          fontSize: "0.8rem",
                          transition: "all 0.2s ease",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          setFilterBtn(3);
                          dispatch(
                            getCaseTemplate({
                              url: `${backend_api}case/template-register/?is_standard=true`,
                              token: token,
                              page: 1,
                              pageSize: pageSize,
                            })
                          );
                        }}
                      >
                        Standard Templates
                      </Button>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        alignItems: "center",
                      }}
                    >
                      <Box>
                        <TextField
                          fullWidth
                          placeholder="Search Template"
                          variant="outlined"
                          size="small"
                          // value={searchQuery}
                          // onChange={(e) => setSearchQuery(e.target.value)}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon />
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            borderRadius: 2,
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 2,
                            },
                          }}
                        />
                      </Box>
                      <Button
                        variant="outlined"
                        color="primary"
                        startIcon={<FilterListRoundedIcon />}
                      >
                        Filter
                      </Button>
                    </Box>
                  </Box>
                  {loading ? (
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fill, minmax(300px, 1fr))",
                        gap: "1rem",
                      }}
                    >
                      {[...Array(6)].map((_, index) => (
                        <TemplateCardSkeleton key={index} />
                      ))}
                    </Box>
                  ) : error ? (
                    <Box sx={{ textAlign: "center", py: 4 }}>
                      <Typography color="error">
                        Error loading templates: {error}
                      </Typography>
                    </Box>
                  ) : allCaseTemplate?.length === 0 ? (
                    <NoTemplateFound />
                  ) : (
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fill, minmax(300px, 1fr))",
                        gap: "1rem",
                      }}
                    >
                      {allCaseTemplate?.map((template) => (
                        <Box
                          key={template.id}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.5rem",
                            height: "100%",
                          }}
                        >
                          <Box
                            sx={{
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              position: "relative",
                              borderRadius: "0.625rem",
                              border: "1px solid #DADADA",
                              overflow: "hidden",
                              "&:hover ": {
                                boxShadow: "0rem 0rem 0.5rem #0000001a",
                              },
                              "&:hover .action-box": {
                                bottom: "0rem",
                                transform: "translateY(0)",
                                opacity: 1,
                              },
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "0.4rem",
                                p: "0.5rem",
                                bgcolor: "#F5F5F5",
                              }}
                            >
                              <Tooltip title={template.template_name}>
                                <Typography
                                  variant="body1"
                                  sx={{
                                    textTransform: "capitalize",
                                    fontSize: "1rem",
                                    fontWeight: "500",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    cursor: "pointer",
                                  }}
                                >
                                  {template.template_name}
                                </Typography>
                              </Tooltip>
                              {template?.is_standard && (
                                <Chip
                                  label="Standard"
                                  size="small"
                                  color="primary"
                                  sx={{
                                    fontSize: "0.7rem",
                                    height: "1.4rem",
                                  }}
                                />
                              )}
                            </Box>
                            <Box
                              sx={{
                                textAlign: "left",
                                p: "1rem",
                                flexGrow: 1,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                gap: "0.5rem",
                              }}
                            >
                              {template?.template_description ? (
                                <Box
                                  sx={{
                                    position: "relative",
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      color: "#606060",
                                      fontSize: "0.9rem",
                                      fontWeight: "400",
                                      textOverflow: "ellipsis",
                                      display: "-webkit-box",
                                      WebkitLineClamp: expandedDesc?.[
                                        template.id
                                      ]
                                        ? "unset"
                                        : 3,
                                      WebkitBoxOrient: "vertical",
                                      whiteSpace: "normal",
                                      height:
                                        template.template_description.length >
                                        120
                                          ? "4rem"
                                          : "auto",
                                      overflowY: expandedDesc?.[template.id]
                                        ? "auto"
                                        : "hidden",
                                      wordBreak: "break-word",
                                      ...pageScrollStyle,
                                    }}
                                  >
                                    {template.template_description}
                                  </Typography>

                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      gap: "1rem",
                                    }}
                                  >
                                    {!template?.is_standard && (
                                      <Button
                                        variant="text"
                                        size="small"
                                        sx={{
                                          fontSize: "0.7rem",
                                          textTransform: "none",
                                        }}
                                        onClick={() =>
                                          handleEditDescription(template)
                                        }
                                      >
                                        <i>
                                          <BorderColorRoundedIcon
                                            sx={{ fontSize: "0.7rem" }}
                                          />
                                          Edit Note
                                        </i>
                                      </Button>
                                    )}
                                    {template?.template_description.length >
                                      120 && (
                                      <Button
                                        variant="text"
                                        size="small"
                                        sx={{
                                          p: 0,
                                          minWidth: 0,
                                          fontSize: "0.7rem",
                                          textTransform: "none",
                                        }}
                                        onClick={() =>
                                          setExpandedDesc((prev) => ({
                                            ...prev,
                                            [template.id]: !prev?.[template.id],
                                          }))
                                        }
                                      >
                                        <i>
                                          {expandedDesc?.[template.id]
                                            ? "Read less"
                                            : "Read more"}
                                        </i>
                                      </Button>
                                    )}
                                  </Box>
                                </Box>
                              ) : (
                                <Typography
                                  sx={{
                                    color: "#606060",
                                    fontSize: "0.9rem",
                                    fontWeight: "400",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: "vertical",
                                  }}
                                >
                                  No description available{" "}
                                  <Button
                                    variant="text"
                                    size="small"
                                    sx={{ p: 0, fontSize: "0.7rem" }}
                                    onClick={() => handleAddNote(template)}
                                  >
                                    <i>
                                      <AddRoundedIcon
                                        sx={{ fontSize: "0.7rem" }}
                                      />{" "}
                                      Add Note
                                    </i>
                                  </Button>
                                </Typography>
                              )}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                }}
                              >
                                <ScheduleRoundedIcon
                                  sx={{ fontSize: "1rem", color: "#606060" }}
                                />
                                <Typography
                                  sx={{
                                    color: "#606060",
                                    fontSize: "0.8rem",
                                    fontWeight: "500",
                                  }}
                                >
                                  Update By:{" "}
                                  {template.updated_by
                                    ? typeof template.updated_by === "object"
                                      ? template.updated_by.first_name ||
                                        template.updated_by.email ||
                                        "Unknown"
                                      : template.updated_by
                                    : template.created_by
                                    ? typeof template.created_by === "object"
                                      ? template.created_by.first_name ||
                                        template.created_by.email ||
                                        "Unknown"
                                      : template.created_by
                                    : "System"}
                                </Typography>
                              </Box>
                            </Box>

                            <Box
                              sx={{
                                borderTop: "1px solid #DADADA",
                                height: "2rem",
                                display: "flex",
                                alignItems: "center",
                                gap: "0.4rem",
                                px: "0.5rem",
                              }}
                            >
                              <Typography
                                variant="body1"
                                sx={{
                                  color: "#606060",
                                  fontSize: "0.8rem",
                                  fontWeight: 500,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                Practice Area:
                              </Typography>
                              <Chip
                                label={
                                  template.practice_area?.name || "General"
                                }
                                size="small"
                                sx={{
                                  fontSize: "0.7rem",
                                  fontWeight: 600,
                                  height: "1.4rem",
                                }}
                              />
                            </Box>
                            <Box
                              className="action-box"
                              sx={{
                                position: "absolute",
                                bottom: "-2rem",
                                width: "100%",
                                display: "flex",
                                justifyContent: "flex-end",
                                background: "#FFFFFF40",
                                boxShadow: "0 0.5rem 1rem 0 #1F268780",
                                backdropFilter: "blur(4px)",
                                WebkitBackdropFilter: "blur(4px)",
                                borderRadius: "0.8rem",
                                border: "1px solid #FFFFFF2E",
                                transform: "translateY(1rem)",
                                opacity: 0,
                                transition: "all 0.3s ease",
                                px: "0.5rem",
                                py: "0.2rem",
                                gap: "0.5rem",
                              }}
                            >
                              {template.is_standard ? (
                                <>
                                  <LoadingButton
                                    loading={duplicateLoad}
                                    variant="outlined"
                                    size="small"
                                    endIcon={
                                      <ContentCopyRoundedIcon
                                        sx={{ fontSize: "0.8rem" }}
                                      />
                                    }
                                    onClick={() =>
                                      handleDuplicateTemplate(template)
                                    }
                                  >
                                    Duplicate
                                  </LoadingButton>
                                  <Button
                                    variant="contained"
                                    size="small"
                                    endIcon={
                                      <BorderColorRoundedIcon
                                        sx={{ fontSize: "0.8rem" }}
                                      />
                                    }
                                    onClick={() => handleEditTemplate(template)}
                                  >
                                    Edit
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <Button
                                    variant="contained"
                                    size="small"
                                    endIcon={
                                      <BorderColorRoundedIcon
                                        sx={{ fontSize: "0.8rem" }}
                                      />
                                    }
                                    onClick={() => handleEditTemplate(template)}
                                  >
                                    Edit
                                  </Button>
                                  <LoadingButton
                                    loading={
                                      deleteLoading[template.id] || false
                                    }
                                    variant="outlined"
                                    size="small"
                                    color="error"
                                    startIcon={<DeleteOutlineRounded />}
                                    onClick={() =>
                                      handleDeleteTemplate(template)
                                    }
                                  >
                                    Delete
                                  </LoadingButton>
                                </>
                              )}
                            </Box>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>

                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Pagination
                    page={page}
                    count={count ? Math.ceil(count / pageSize) : 0}
                    variant="outlined"
                    color="primary"
                    size="small"
                    onChange={handlePageChange}
                  />
                </Box>
              </Box>
            </div>
          </div>
        </Box>
      </Box>
    </>
  );
};

export default CaseTemplate;
